import { render, staticRenderFns } from "./egis-icon.vue?vue&type=template&id=e4f5b198"
import script from "./egis-icon.vue?vue&type=script&lang=js"
export * from "./egis-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports